<nz-tag
  *ngIf="tagStatus"
  [nzColor]="tagStatus">
  <ng-container [ngSwitch]="tagStatus">
    <i
      *ngSwitchCase="'success'"
      nz-icon
      nzType="check-circle"></i>
    <i
      *ngSwitchCase="'error'"
      nz-icon
      nzType="close-circle"></i>
    <i
      *ngSwitchCase="'warning'"
      nz-icon
      nzType="exclamation-circle"></i>
    <i
      *ngSwitchCase="'processing'"
      nz-icon></i>
    <i
      *ngSwitchCase="'default'"
      nz-icon></i>
  </ng-container>
  {{ status | titlecase }}
</nz-tag>
